import React from "react";
import { FlatList } from "react-native";

import EmptyList from "@/components/molecules/EmptyList";
import ProductCard from "@/components/molecules/ProductCard";
import ProductCardLoading from "@/components/molecules/ProductCard/ProductCardLoading";

import { ProductListProps } from "./types";

const ProductListMobile = ({
  data,
  isLoading,
  onLoadMore,
  onPressDecrease,
  onPressIncrease,
  onSelect,
}: ProductListProps) => {
  return (
    <FlatList
      data={data}
      numColumns={2}
      showsVerticalScrollIndicator={false}
      nestedScrollEnabled
      keyExtractor={(item, index) => (item ? item?.item?._id : index.toString())}
      onEndReached={onLoadMore}
      onEndReachedThreshold={0.1}
      contentContainerStyle={{ alignItems: "center" }}
      renderItem={({ item }) => {
        return (
          <>
            {isLoading ? (
              <ProductCardLoading />
            ) : (
              <ProductCard
                item={item}
                onPressDecrease={() => onPressDecrease(item)}
                onPressIncrease={() => onPressIncrease(item)}
                onSelect={() => onSelect(item?.item?._id)}
              />
            )}
          </>
        );
      }}
      ListEmptyComponent={<EmptyList />}
    />
  );
};

export default ProductListMobile;
